import { JsonObject, JsonProperty } from 'json2typescript';
import { OperativeBankInfoResponseInterface } from '../interfaces/bankinfo.interface';

@JsonObject('OperativeBankInfoResponseModel')
export class OperativeBankInfoResponseModel
  implements OperativeBankInfoResponseInterface
{
  @JsonProperty('ABA', String, true)
  aba: string = undefined;

  @JsonProperty('BeneficiaryBankAddress', String, true)
  beneficiaryBankAddress: string = undefined;

  @JsonProperty('BankAccount', String, true)
  bankAccount: string = undefined;

  @JsonProperty('BankName', String, true)
  bankName: string = undefined;

  @JsonProperty('BankAddress', String, true)
  bankAddress: string = undefined;

  @JsonProperty('BankCity', String, true)
  bankCity: string = undefined;

  @JsonProperty('BankCP', String, true)
  bankCP: string = undefined;

  @JsonProperty('BankCountry', String, true)
  bankCountry: string = undefined;

  @JsonProperty('SWIFT', String, true)
  swift: string = undefined;

  @JsonProperty('BeneficiaryName', String, true)
  beneficiaryName: string = undefined;

  @JsonProperty('BeneficiaryAdress', String, true)
  beneficiaryAdress: string = undefined;

  @JsonProperty('beneficiaryCity', String, true)
  beneficiaryCity: string = undefined;

  @JsonProperty('BeneficiaryCP', String, true)
  beneficiaryCP: string = undefined;

  @JsonProperty('BeneficiaryCountry', String, true)
  beneficiaryCountry: string = undefined;

  @JsonProperty('Message', String, true)
  message: string = undefined;

  @JsonProperty('CCY', String, true)
  ccy: string = undefined;

  @JsonProperty('FundLocation', String, true)
  fundLocation: string = undefined;
}
